import { render, staticRenderFns } from "./invitationDetails.vue?vue&type=template&id=4876a296&"
import script from "./invitationDetails.vue?vue&type=script&lang=js&"
export * from "./invitationDetails.vue?vue&type=script&lang=js&"
import style0 from "./invitationDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports